export default function (state, getters) {
    let filters = getters['filters'];
    let filter = filters.filter(i => {
        return i.id === state.default;
    })[0];
    return filter ? filter : getters['filters'][0];
}